/* ============================================================
   Klartext-Quiz · Logik
   Texte und Reihenfolge stehen in sections/klartext-quiz.liquid (Block "quiz-daten").
   Hier muss man nur ran für: Mailtool (MAILTOOL-ANBINDUNG) oder neue Fragetypen.
   ============================================================ */
(function () {
  'use strict';

  var root = document.querySelector('[data-kq-root]');
  var datenEl = document.getElementById('quiz-daten');
  if (!root || !datenEl) return;

  var D = JSON.parse(datenEl.textContent);
  var buehne = root.querySelector('[data-kq-buehne]');
  var balken = root.querySelector('[data-kq-balken]');
  var fortschritt = root.querySelector('[data-kq-fortschritt]');
  var zurueckKnopf = root.querySelector('[data-kq-zurueck]');

  // config.id trennt mehrere Quizze (Bruno ohne id, Clara mit "clara"): eigener Speicher, Kennung an jedem Ereignis.
  // quizId (je Test) vor config.id (je Persona), damit sich auch Claras Tests untereinander nicht in die Quere kommen.
  var QUIZ_ID = D.quizId || (D.config && D.config.id) || '';
  var SPEICHER_KEY = 'klartext-quiz-v1' + (QUIZ_ID ? '-' + QUIZ_ID : '');
  var AUSWERTUNG_MS = 2600; // Dauer des Auswertungs-Bildschirms vor dem Ergebnis
  var FRAGEN_GESAMT = D.schritte.filter(function (s) { return s.typ !== 'karte'; }).length;
  var WENIG_BEWEGUNG = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Ablauf: Start, alle Schritte, Auswertung, ggf. Mail, Ergebnis ---------- */

  var ablauf = [{ typ: 'start' }]
    .concat(D.schritte)
    .concat([{ typ: 'auswertung' }])
    .concat(D.config.mail.aktiv ? [{ typ: 'mail' }] : [])
    .concat([{ typ: 'ergebnis' }]);

  /* ---------- Zustand (nur im Browser, keine personenbezogenen Daten) ---------- */

  var zustand = laden() || { pos: 0, antworten: {}, muster: null, gemeldet: {} };
  var vorname = ''; // bewusst nicht gespeichert

  function laden() {
    try {
      var roh = sessionStorage.getItem(SPEICHER_KEY);
      return roh ? JSON.parse(roh) : null;
    } catch (e) { return null; }
  }
  function speichern() {
    try { sessionStorage.setItem(SPEICHER_KEY, JSON.stringify(zustand)); } catch (e) { /* privater Modus o.ä. */ }
  }

  /* ---------- Messung ----------
     Ereignisse gehen an window.dataLayer (für Tag-Manager/Pixel) und an Shopify.analytics
     (für ein Custom Pixel unter Einstellungen > Kundenereignisse). Keine personenbezogenen Daten.

     Die Namen sind absichtlich wenige und fest: quiz_start, quiz_frage, quiz_ergebnis,
     quiz_zum_buch, quiz_weiterer_test, quiz_mail_*, quiz_ton_*. Was den Fall unterscheidet,
     steht in den Daten (quiz, nr, gesamt, muster), nicht im Namen. Nur so lässt sich ein
     Trichter über alle Tests bauen; mit der Fragenummer im Namen hat jede Frage ihre eigene
     Zeile und man vergleicht nichts mehr.

     EMPFÄNGER ANKLEMMEN: window.kqMelden setzen, bevor das Quiz lädt. Die Funktion bekommt
     (name, daten) und kann die Daten irgendwohin schicken, ohne dass diese Datei sich ändert. */

  window.dataLayer = window.dataLayer || [];

  function melden(name, daten) {
    daten = Object.assign({ quiz: QUIZ_ID || 'rueckzug' }, daten || {});
    window.dataLayer.push(Object.assign({ event: name }, daten));
    try {
      if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') {
        Shopify.analytics.publish(name, daten);
      }
    } catch (e) { /* Messung darf das Quiz nie blockieren */ }
    try {
      if (typeof window.kqMelden === 'function') window.kqMelden(name, daten);
    } catch (e) { /* dito */ }
  }

  /* Für Abbruch-pro-Frage nur einmal pro Sitzung melden, sonst zählt Zurückgehen doppelt.
     Der Schlüssel ist vom Namen getrennt, weil mehrere Ereignisse denselben Namen tragen
     (quiz_frage für jede Frage) und trotzdem jedes einzeln einmal gemeldet werden muss. */
  function einmalMelden(schluessel, name, daten) {
    if (zustand.gemeldet[schluessel]) return;
    zustand.gemeldet[schluessel] = true;
    melden(name, daten);
  }

  /* ---------- UTM-Parameter ----------
     Alles, was mit utm_ beginnt, wird an die Verkaufsseite weitergereicht.
     utm_content wird auf das Muster gesetzt. */

  var UTM_KEY = 'klartext-quiz-utm';
  var utm = (function () {
    var gefunden = {};
    new URLSearchParams(location.search).forEach(function (wert, schluessel) {
      if (schluessel.indexOf('utm_') === 0) gefunden[schluessel] = wert;
    });
    try {
      if (Object.keys(gefunden).length) sessionStorage.setItem(UTM_KEY, JSON.stringify(gefunden));
      else gefunden = JSON.parse(sessionStorage.getItem(UTM_KEY) || '{}');
    } catch (e) { /* egal */ }
    return gefunden;
  })();

  function buchLink(muster) {
    var ziel = (D.config.buchUrl && D.config.buchUrl[muster]) || '/buch';
    var url = new URL(ziel, location.origin);
    Object.keys(utm).forEach(function (k) { url.searchParams.set(k, utm[k]); });
    // Ohne eingehende UTM trotzdem erkennbar machen, dass der Besuch aus dem Quiz kam.
    if (!utm.utm_source) {
      url.searchParams.set('utm_source', 'quiz');
      url.searchParams.set('utm_medium', 'quiz-seite');
    }
    url.searchParams.set('utm_content', muster);
    // Welcher Test es war, damit in der Bestellung nicht nur das Ergebnis steht.
    url.searchParams.set('utm_term', QUIZ_ID || 'rueckzug');
    return url.pathname + url.search;
  }

  /* ---------- MAILTOOL-ANBINDUNG: Shopifys eigene Kundenliste ----------
     Wird nur aufgerufen, wenn config.mail.aktiv = true. Angebunden am 20.10.2026.

     Der Weg ist Shopifys Newsletter-Formular: POST an /contact mit
     form_type=customer. Shopify legt daraus einen Kunden an und setzt die
     Marketing-Zustimmung. Kein Drittanbieter, keine zusätzlichen Cookies,
     nichts, was neu in die Datenschutzerklärung muss.

     WICHTIG, sonst ist die Liste in Deutschland wertlos:
     Admin > Einstellungen > Kundendatenschutz > Double-Opt-in für Marketing
     muss AN sein. Sonst trägt Shopify sie ohne Bestätigungsmail ein, und
     eine Einwilligung ohne Bestätigung ist hier nichts wert.

     Die Tags hängen am Kundendatensatz und sind der Hebel für spätere
     Strecken: quiz, quiz-<test>, muster-<ergebnis>. Damit lässt sich in
     Shopify Email ein Segment je Muster bauen, etwa alle mit muster-funkstille,
     und genau die bekommen die Mail zu ihrem Band.

     Fällt der Aufruf durch, fängt der Aufrufer das ab: Das Ergebnis wird
     immer gezeigt. Ein Fehler hier darf den Test nie blockieren. */

  function mailTags(daten) {
    var tags = ['quiz'];
    tags.push('quiz-' + (QUIZ_ID || 'rueckzug'));
    if (daten.muster) tags.push('muster-' + daten.muster);
    return tags.join(',');
  }

  function mailEintragen(daten) {
    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[email]', daten.email);
    if (daten.vorname) fd.append('contact[first_name]', daten.vorname);
    fd.append('contact[tags]', mailTags(daten));
    return fetch('/contact', {
      method: 'POST',
      body: fd,
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    }).then(function (r) {
      // Shopify antwortet mit einer Weiterleitung auf die Seite. Alles ausser
      // einem Serverfehler werten wir als angekommen.
      if (r.status >= 500) throw new Error('Mailtool antwortet mit ' + r.status);
      return r;
    });
  }

  /* ============================================================
     BELOHNUNG
     Jede Auswahl soll sich gut anfühlen: Welle am Tippunkt, Karte federt,
     Haken zeichnet sich, Funken fliegen, das Handy tickt kurz.
     Alles aus bei "Bewegung reduzieren" im Betriebssystem.
     ============================================================ */

  var FUNKEN_FARBEN = ['#A85C42', '#C8765A', '#E3B98F', '#D9A066', '#8E4B34'];

  /* Vibration
     Android: navigator.vibrate. Unter etwa 25 ms spüren viele Geräte nichts, deshalb Mindestlänge.
     iPhone (ab iOS 18): kein vibrate, aber das Umlegen eines unsichtbaren Schalters löst
     dort ein kurzes Antippen-Gefühl aus. Im Instagram-Browser kann beides gesperrt sein. */
  var iosSchalter = null;
  function tick(ms) {
    try {
      if (navigator.vibrate) { navigator.vibrate(Math.max(ms || 0, 28)); return; }
      if (!iosSchalter) {
        iosSchalter = document.createElement('label');
        iosSchalter.setAttribute('aria-hidden', 'true');
        iosSchalter.style.cssText = 'position:fixed;left:-200px;top:0;opacity:0;pointer-events:none;';
        var cb = document.createElement('input');
        cb.type = 'checkbox';
        cb.setAttribute('switch', '');
        cb.tabIndex = -1;
        iosSchalter.appendChild(cb);
        document.body.appendChild(iosSchalter);
      }
      iosSchalter.click();
    } catch (e) { /* Vibration ist Beiwerk */ }
  }

  /* ============================================================
     KLANG
     Alle Töne werden live im Browser erzeugt (keine Audiodateien, nichts zu laden).
     Warmer, marimba-artiger Anschlag. Jede beantwortete Frage klingt einen Ton höher,
     das Quiz "steigt" also hörbar bis zum Ergebnis.
     Ein-/Ausschalten oben rechts, gemerkt im Browser.
     ============================================================ */

  var TON_KEY = 'klartext-quiz-ton';
  var tonAn = (function () { try { return localStorage.getItem(TON_KEY) !== 'aus'; } catch (e) { return true; } })();
  var ctx = null, master = null;

  function audio() {
    if (!tonAn) return null;
    try {
      if (!ctx) {
        var AC = window.AudioContext || window.webkitAudioContext;
        if (!AC) return null;
        ctx = new AC();
        var komp = ctx.createDynamicsCompressor();
        master = ctx.createGain();
        master.gain.value = 0.32;
        master.connect(komp);
        komp.connect(ctx.destination);
      }
      if (ctx.state === 'suspended') ctx.resume();
      return ctx;
    } catch (e) { return null; }
  }

  // Ein Anschlag: Grundton plus kurzer, heller Oberton (klingt nach Holz statt nach Piepser)
  function note(freq, start, dauer, laut, typ) {
    var a = audio(); if (!a) return;
    var t = a.currentTime + (start || 0);
    [[1, laut, dauer, typ || 'sine'], [4, laut * 0.22, dauer * 0.35, 'sine'], [2, laut * 0.18, dauer * 0.6, 'triangle']].forEach(function (p) {
      var o = a.createOscillator(), g = a.createGain();
      o.type = p[3];
      o.frequency.value = freq * p[0];
      g.gain.setValueAtTime(0.0001, t);
      g.gain.exponentialRampToValueAtTime(p[1], t + 0.006);
      g.gain.exponentialRampToValueAtTime(0.0001, t + p[2]);
      o.connect(g); g.connect(master);
      o.start(t); o.stop(t + p[2] + 0.05);
    });
  }

  // Weiches Rauschen, das von dunkel nach hell zieht (Übergang)
  function hauch(start, dauer, laut) {
    var a = audio(); if (!a) return;
    var t = a.currentTime + (start || 0);
    var len = Math.floor(a.sampleRate * dauer);
    var buf = a.createBuffer(1, len, a.sampleRate);
    var d = buf.getChannelData(0);
    for (var i = 0; i < len; i++) d[i] = Math.random() * 2 - 1;
    var src = a.createBufferSource(); src.buffer = buf;
    var f = a.createBiquadFilter(); f.type = 'bandpass'; f.Q.value = 1.4;
    f.frequency.setValueAtTime(500, t);
    f.frequency.exponentialRampToValueAtTime(3200, t + dauer);
    var g = a.createGain();
    g.gain.setValueAtTime(0.0001, t);
    g.gain.exponentialRampToValueAtTime(laut, t + dauer * 0.35);
    g.gain.exponentialRampToValueAtTime(0.0001, t + dauer);
    src.connect(f); f.connect(g); g.connect(master);
    src.start(t); src.stop(t + dauer);
  }

  // Pentatonik über zwei Oktaven: klingt immer harmonisch, egal in welcher Reihenfolge
  var LEITER = [523.25, 587.33, 659.25, 783.99, 880, 1046.5, 1174.66, 1318.51, 1567.98, 1760, 2093];
  function stufe() {
    var n = 0;
    for (var k in zustand.antworten) if (zustand.antworten.hasOwnProperty(k)) n++;
    return n;
  }

  var klang = {
    waehlen: function (extra) {
      var f = LEITER[Math.min(LEITER.length - 1, stufe() + (extra || 0))];
      note(f, 0, 0.5, 0.5);
      note(f * 1.5, 0.045, 0.35, 0.16); // kleiner Funke obendrauf
    },
    ab: function () { note(392, 0, 0.18, 0.18, 'triangle'); },
    weiter: function () {
      var f = LEITER[Math.min(LEITER.length - 1, stufe())];
      hauch(0, 0.28, 0.05);
      note(f, 0.02, 0.35, 0.3);
      note(f * 1.5, 0.09, 0.45, 0.28);
    },
    regler: function (p) { note(330 + p * 520, 0, 0.09, 0.14); },
    karte: function () {
      [220, 261.63, 329.63, 440].forEach(function (f, i) { note(f, i * 0.06, 1.6, 0.11); });
    },
    ding: function (i) { note([659.25, 783.99, 1046.5][i] || 1046.5, 0, 0.7, 0.35); },
    ergebnis: function () {
      [523.25, 659.25, 783.99, 1046.5, 1318.51, 1567.98].forEach(function (f, i) { note(f, i * 0.075, 1.1, 0.34); });
      [2093, 2637, 3136, 2349].forEach(function (f, i) { note(f, 0.5 + i * 0.09, 0.5, 0.07); });
      hauch(0.42, 0.6, 0.03);
    },
    fehler: function () { note(185, 0, 0.22, 0.25, 'triangle'); note(175, 0.08, 0.22, 0.2, 'triangle'); },
    start: function () {
      hauch(0, 0.35, 0.05);
      [392, 523.25, 659.25].forEach(function (f, i) { note(f, 0.03 + i * 0.07, 0.6, 0.3); });
    }
  };

  var tonKnopf = root.querySelector('[data-kq-ton]');
  function tonAnzeigen() {
    tonKnopf.setAttribute('aria-pressed', tonAn ? 'true' : 'false');
    tonKnopf.setAttribute('aria-label', tonAn ? 'Ton aus' : 'Ton an');
    tonKnopf.classList.toggle('is-aus', !tonAn);
  }
  if (tonKnopf) {
    tonAnzeigen();
    tonKnopf.addEventListener('click', function () {
      tonAn = !tonAn;
      try { localStorage.setItem(TON_KEY, tonAn ? 'an' : 'aus'); } catch (e) { /* egal */ }
      tonAnzeigen();
      if (tonAn) note(783.99, 0, 0.4, 0.3);
      melden(tonAn ? 'quiz_ton_an' : 'quiz_ton_aus');
    });
  }

  function welle(knopf, ev) {
    if (WENIG_BEWEGUNG) return;
    var r = knopf.getBoundingClientRect();
    var x = ev && ev.clientX ? ev.clientX - r.left : r.width / 2;
    var y = ev && ev.clientY ? ev.clientY - r.top : r.height / 2;
    var w = document.createElement('span');
    w.className = 'kq-welle';
    var groesse = Math.max(r.width, r.height) * 2.2;
    w.style.width = w.style.height = groesse + 'px';
    w.style.left = (x - groesse / 2) + 'px';
    w.style.top = (y - groesse / 2) + 'px';
    knopf.appendChild(w);
    setTimeout(function () { w.remove(); }, 700);
  }

  // Funken aus einem Punkt. stark = größer und weiter (Ergebnis, Fortschritt).
  function funken(x, y, anzahl, stark) {
    if (WENIG_BEWEGUNG || !Element.prototype.animate) return;
    for (var i = 0; i < anzahl; i++) {
      var f = document.createElement('span');
      var form = Math.random();
      f.className = 'kq-funke' + (form < 0.3 ? ' kq-funke--strich' : form < 0.55 ? ' kq-funke--raute' : '');
      var g = (stark ? 8 : 6) + Math.random() * (stark ? 8 : 5);
      f.style.width = f.className.indexOf('strich') > -1 ? '3px' : g + 'px';
      f.style.height = g + 'px';
      f.style.left = x + 'px';
      f.style.top = y + 'px';
      f.style.background = FUNKEN_FARBEN[(Math.random() * FUNKEN_FARBEN.length) | 0];
      document.body.appendChild(f);

      var winkel = (Math.PI * 2 * i) / anzahl + (Math.random() - 0.5) * 0.6;
      var weite = (stark ? 90 : 50) + Math.random() * (stark ? 120 : 55);
      var dx = Math.cos(winkel) * weite;
      var dy = Math.sin(winkel) * weite;
      var dreh = (Math.random() - 0.5) * 540;
      var dauer = (stark ? 1100 : 700) + Math.random() * 350;

      var anim = f.animate([
        { transform: 'translate(-50%,-50%) scale(.4) rotate(0deg)', opacity: 1 },
        { transform: 'translate(calc(-50% + ' + dx * 0.8 + 'px), calc(-50% + ' + dy * 0.8 + 'px)) scale(1.1) rotate(' + dreh * 0.6 + 'deg)', opacity: 1, offset: 0.55 },
        { transform: 'translate(calc(-50% + ' + dx + 'px), calc(-50% + ' + (dy + (stark ? 40 : 14)) + 'px)) scale(.2) rotate(' + dreh + 'deg)', opacity: 0 }
      ], { duration: dauer, easing: 'cubic-bezier(.15,.8,.35,1)' });
      anim.onfinish = (function (el) { return function () { el.remove(); }; })(f);
    }
  }

  function funkenAus(el, anzahl, stark) {
    var r = el.getBoundingClientRect();
    funken(r.left + r.width / 2, r.top + r.height / 2, anzahl, stark);
  }

  function nachklang(el, klasse, ms) {
    el.classList.remove(klasse);
    void el.offsetWidth; // Animation neu starten
    el.classList.add(klasse);
    setTimeout(function () { el.classList.remove(klasse); }, ms);
  }

  // Weiter-Knopf wird lebendig, sobald etwas gewählt ist.
  function weiterFreigeben(knopf, an) {
    var vorher = knopf.disabled;
    knopf.disabled = !an;
    if (an && vorher) nachklang(knopf, 'is-wach', 900);
  }

  /* ---------- Bausteine ---------- */

  function el(tag, klasse, text) {
    var e = document.createElement(tag);
    if (klasse) e.className = klasse;
    if (text != null) setzeText(e, text);
    return e;
  }

  // Noch nicht gelieferte Texte gestrichelt markieren, damit sie niemand übersieht.
  function setzeText(e, text) {
    e.textContent = text;
    if (typeof text === 'string' && text.indexOf('PLATZHALTER:') === 0) e.classList.add('kq-platzhalter');
  }

  // ton: false = kein Standard-Weiter-Klang (wenn der Aufrufer selbst einen spielt)
  function knopf(text, klasse, beiKlick, ton) {
    var b = el('button', 'kq-knopf' + (klasse ? ' ' + klasse : ''), text);
    b.type = 'button';
    b.addEventListener('click', function (ev) {
      welle(b, ev);
      if (ton !== false) { klang.weiter(); tick(18); }
      beiKlick(ev);
    });
    return b;
  }

  var HAKEN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" fill="none" stroke="#A85C42" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" pathLength="1"/></svg>';

  function option(opt, mehrfach) {
    var b = el('button', 'kq-option' + (mehrfach ? ' kq-option--mehrfach' : ''));
    b.type = 'button';
    var marke = el('span', 'kq-option__marke');
    marke.innerHTML = HAKEN;
    b.appendChild(marke);
    b.appendChild(el('span', 'kq-option__text', opt.text));
    return b;
  }

  // Die eigentliche Belohnung beim Antippen einer Antwort
  function belohnen(b, ev, extra) {
    welle(b, ev);
    klang.waehlen(extra);
    nachklang(b, 'is-pop', 450);
    var marke = b.querySelector('.kq-option__marke');
    var ziel = marke && getComputedStyle(marke).display !== 'none' ? marke : b;
    funkenAus(ziel, 18, false);
    tick(12);
  }

  /* ---------- Navigation ---------- */

  function zeige(pos) {
    zustand.pos = pos;
    speichern();

    var alt = buehne.querySelector('.kq-screen');
    var neu = baue(ablauf[pos]);

    function tauschen() {
      buehne.innerHTML = '';
      buehne.appendChild(neu);
      window.scrollTo(0, 0);
      var fokus = neu.querySelector('h1, h2, .kq-frage, .kq-karte__text');
      if (fokus) { fokus.setAttribute('tabindex', '-1'); fokus.focus({ preventScroll: true }); }
      if (neu._nachdemZeigen) neu._nachdemZeigen();
    }

    if (alt && !WENIG_BEWEGUNG) {
      alt.classList.add('is-raus');
      setTimeout(tauschen, 180);
    } else {
      tauschen();
    }
    kopfzeile(pos);
  }

  function weiter() { if (zustand.pos < ablauf.length - 1) zeige(zustand.pos + 1); }

  function zurueck() {
    var ziel = zustand.pos - 1;
    if (ablauf[ziel] && ablauf[ziel].typ === 'auswertung') ziel--; // Auswertung nicht nochmal abspielen
    if (ziel >= 1) zeige(ziel);
  }

  zurueckKnopf.addEventListener('click', zurueck);

  var letzterAnteil = 0;
  function kopfzeile(pos) {
    var schritt = ablauf[pos];
    var imQuiz = ['start', 'ergebnis', 'auswertung'].indexOf(schritt.typ) === -1;
    fortschritt.hidden = !imQuiz;
    zurueckKnopf.hidden = !imQuiz || pos <= 1;

    // Anteil beantworteter Fragen bis hierhin. Startet leicht gefüllt, damit Frage 1 nicht nach "null" aussieht.
    var erledigt = 0;
    for (var i = 1; i < pos; i++) if (ablauf[i].nr) erledigt++;
    var anteil = schritt.typ === 'mail' ? 1 : Math.max(0.04, erledigt / FRAGEN_GESAMT);
    balken.style.width = (anteil * 100).toFixed(1) + '%';

    // Beim Vorwärtsgehen: Schimmer über den Balken und ein paar Funken an der Spitze
    if (imQuiz && anteil > letzterAnteil + 0.001) {
      nachklang(fortschritt, 'is-schub', 900);
      setTimeout(function () {
        var r = balken.getBoundingClientRect();
        funken(r.right, r.top + r.height / 2, 7, false);
      }, 420);
    }
    letzterAnteil = anteil;
  }

  /* ---------- Bildschirme ---------- */

  function baue(s) {
    switch (s.typ) {
      case 'start': return baueStart();
      case 'karte': return baueKarte(s);
      case 'auswertung': return baueAuswertung();
      case 'mail': return baueMail();
      case 'ergebnis': return baueErgebnis();
      default: return baueFrage(s);
    }
  }

  function baueStart() {
    var w = el('section', 'kq-screen kq-start');
    w.appendChild(el('p', 'kq-eyebrow', D.start.eyebrow));
    w.appendChild(el('h1', 'kq-titel', D.start.titel));
    w.appendChild(el('p', 'kq-text', D.start.text));
    w.appendChild(knopf(D.start.knopf, 'kq-knopf--start', function () {
      melden('quiz_start');
      klang.start();
      tick(30);
      weiter();
    }, false));
    w.appendChild(el('p', 'kq-klein', D.start.hinweis));
    return w;
  }

  // Zwischenkarte: Text baut sich Wort für Wort auf
  function baueKarte(s) {
    var w = el('section', 'kq-screen');
    var k = el('div', 'kq-karte');
    k.appendChild(el('p', 'kq-eyebrow', 'Kurz dazwischen'));
    var p = el('p', 'kq-karte__text');
    s.text.split(' ').forEach(function (wort, i) {
      var sp = el('span', 'kq-wort', wort);
      sp.style.animationDelay = (120 + i * 45) + 'ms';
      p.appendChild(sp);
      p.appendChild(document.createTextNode(' '));
    });
    k.appendChild(p);
    k.appendChild(knopf(s.knopf || 'Weiter', '', weiter));
    w.appendChild(k);
    w._nachdemZeigen = function () { klang.karte(); };
    return w;
  }

  /* ---------- PUNKTEWERTUNG ----------
     Normalfall: eine Frage traegt setztMuster und bestimmt das Ergebnis.
     Bei config.wertung = "punkte" zaehlt stattdessen die Summe: jede Option
     kann punkte tragen, z. B. "punkte": { "band2": 3, "band1": 1 }.
     Gleichstand entscheidet die Reihenfolge in config.wertungReihenfolge,
     sonst die Reihenfolge der Ergebnisse. Ohne jeden Punkt greift
     config.wertungFallback. Wird bei jeder Antwort neu gerechnet, damit
     Zurueckgehen und Umentscheiden sauber durchschlagen. */

  function istPunktewertung() {
    return !!(D.config && D.config.wertung === 'punkte');
  }

  /* Vorfahrt: Eine Option kann "erzwingt": "<ergebnis>" tragen. Ist sie
     angeklickt, gewinnt dieses Ergebnis, egal wie die Punkte stehen. Gedacht
     fuer Antworten, die nicht ueberstimmt werden duerfen, etwa Hinweise auf
     eine Lage, in der ein Buch nicht die richtige Antwort ist.
     Mehrere erzwungene Treffer: der erste in config.wertungReihenfolge. */
  function erzwungenesMuster() {
    var treffer = [];
    (D.schritte || []).forEach(function (s) {
      if (s.nr == null) return;
      var a = zustand.antworten[s.nr];
      if (a == null) return;
      var gewaehlt = Array.isArray(a) ? a : [a];
      (s.optionen || []).forEach(function (opt) {
        if (opt.erzwingt && gewaehlt.indexOf(opt.wert) > -1) treffer.push(opt.erzwingt);
      });
    });
    if (!treffer.length) return null;
    var reihenfolge = (D.config && D.config.wertungReihenfolge) || Object.keys(D.ergebnisse || {});
    for (var i = 0; i < reihenfolge.length; i++) {
      if (treffer.indexOf(reihenfolge[i]) > -1) return reihenfolge[i];
    }
    return treffer[0];
  }

  function musterAusPunkten() {
    var erzwungen = erzwungenesMuster();
    if (erzwungen) return erzwungen;
    var summe = {};
    (D.schritte || []).forEach(function (s) {
      if (s.nr == null) return;
      var a = zustand.antworten[s.nr];
      if (a == null) return;
      var gewaehlt = Array.isArray(a) ? a : [a];
      (s.optionen || []).forEach(function (opt) {
        if (!opt.punkte || gewaehlt.indexOf(opt.wert) === -1) return;
        Object.keys(opt.punkte).forEach(function (k) {
          summe[k] = (summe[k] || 0) + opt.punkte[k];
        });
      });
    });
    var reihenfolge = (D.config && D.config.wertungReihenfolge) || Object.keys(D.ergebnisse || {});
    var best = null, bestWert = -1;
    reihenfolge.forEach(function (k) {
      var w = summe[k] || 0;
      if (w > bestWert) { bestWert = w; best = k; }
    });
    if (bestWert <= 0 && D.config && D.config.wertungFallback) return D.config.wertungFallback;
    return best;
  }

  function beantwortet(s, wert) {
    zustand.antworten[s.nr] = wert;
    if (s.setztMuster) zustand.muster = wert;
    if (istPunktewertung()) zustand.muster = musterAusPunkten();
    speichern();
    einmalMelden('frage-' + s.nr, 'quiz_frage', { nr: s.nr, gesamt: FRAGEN_GESAMT });
  }

  function baueFrage(s) {
    var w = el('section', 'kq-screen');
    w.appendChild(el('p', 'kq-nr', 'Frage ' + s.nr + ' von ' + FRAGEN_GESAMT));
    w.appendChild(el('h2', 'kq-frage', s.frage));
    if (s.hilfe) w.appendChild(el('p', 'kq-hilfe', s.hilfe));

    var bisher = zustand.antworten[s.nr];

    if (s.typ === 'einfach' || s.typ === 'janein' || s.typ === 'zweiknoepfe') {
      // Eine Antwort, umentscheiden geht jederzeit. Weiter erst per Knopf.
      var gewaehlt1 = bisher != null ? bisher : null;
      var liste = el('div', 'kq-optionen');
      liste.setAttribute('role', 'radiogroup');
      if (s.typ !== 'einfach') liste.classList.add('kq-optionen--paar');
      if (s.typ === 'janein') liste.classList.add('kq-optionen--janein');
      var weiter1 = knopf('Weiter', 'kq-weiter', function () {
        if (gewaehlt1 == null) return;
        beantwortet(s, gewaehlt1);
        weiter();
      });
      weiter1.disabled = gewaehlt1 == null;
      s.optionen.forEach(function (opt) {
        var b = option(opt, false);
        b.setAttribute('role', 'radio');
        b.setAttribute('aria-checked', gewaehlt1 === opt.wert ? 'true' : 'false');
        if (gewaehlt1 === opt.wert) b.classList.add('is-gewaehlt');
        b.addEventListener('click', function (ev) {
          if (gewaehlt1 === opt.wert) { nachklang(b, 'is-pop', 450); return; }
          gewaehlt1 = opt.wert;
          liste.querySelectorAll('.kq-option').forEach(function (x) {
            x.classList.remove('is-gewaehlt');
            x.setAttribute('aria-checked', 'false');
          });
          b.classList.add('is-gewaehlt');
          b.setAttribute('aria-checked', 'true');
          belohnen(b, ev);
          weiterFreigeben(weiter1, true);
        });
        liste.appendChild(b);
      });
      w.appendChild(liste);
      w.appendChild(weiter1);
    }

    else if (s.typ === 'mehrfach') {
      var gewaehlt = Array.isArray(bisher) ? bisher.slice() : [];
      var liste2 = el('div', 'kq-optionen');
      var weiterKnopf = knopf('Weiter', 'kq-weiter', function () {
        if (!gewaehlt.length) return;
        beantwortet(s, gewaehlt);
        weiter();
      });
      weiterKnopf.disabled = !gewaehlt.length;
      s.optionen.forEach(function (opt) {
        var b = option(opt, true);
        b.setAttribute('aria-pressed', gewaehlt.indexOf(opt.wert) > -1 ? 'true' : 'false');
        if (gewaehlt.indexOf(opt.wert) > -1) b.classList.add('is-gewaehlt');
        b.addEventListener('click', function (ev) {
          var i = gewaehlt.indexOf(opt.wert);
          var an = i === -1;
          if (an) gewaehlt.push(opt.wert); else gewaehlt.splice(i, 1);
          b.classList.toggle('is-gewaehlt', an);
          b.setAttribute('aria-pressed', an ? 'true' : 'false');
          if (an) belohnen(b, ev, gewaehlt.length - 1); else { nachklang(b, 'is-ab', 300); klang.ab(); tick(10); }
          weiterFreigeben(weiterKnopf, gewaehlt.length > 0);
        });
        liste2.appendChild(b);
      });
      w.appendChild(liste2);
      w.appendChild(weiterKnopf);
    }

    else if (s.typ === 'regler') {
      var wert = typeof bisher === 'number' ? bisher : s.start;
      var box = el('div', 'kq-regler');
      var anzeige = el('output', 'kq-regler__wert', String(wert));
      var input = document.createElement('input');
      input.type = 'range';
      input.min = s.min; input.max = s.max; input.step = 1; input.value = wert;
      input.setAttribute('aria-label', s.frage);
      function fuellen() {
        var p = (input.value - s.min) / (s.max - s.min);
        input.style.setProperty('--kq-fuellung', (p * 100) + '%');
        // Je höher der Wert, desto kräftiger und größer die Zahl
        anzeige.style.setProperty('--kq-staerke', (35 + p * 65).toFixed(0) + '%');
        anzeige.style.setProperty('--kq-groesse', (1 + p * 0.35).toFixed(3));
      }
      fuellen();
      var letzter = String(wert);
      input.addEventListener('input', function () {
        if (input.value === letzter) return;
        letzter = input.value;
        anzeige.textContent = input.value;
        nachklang(anzeige, 'is-hupf', 180);
        tick(10);
        fuellen();
        klang.regler((input.value - s.min) / (s.max - s.min));
        if (input.value === String(s.max)) funkenAus(anzeige, 10, false);
      });
      var enden = el('div', 'kq-regler__enden');
      enden.appendChild(el('span', '', s.links));
      enden.appendChild(el('span', '', s.rechts));
      box.appendChild(anzeige);
      box.appendChild(input);
      box.appendChild(enden);
      w.appendChild(box);
      w.appendChild(knopf('Weiter', 'kq-weiter', function () {
        beantwortet(s, parseInt(input.value, 10));
        weiter();
      }));
    }

    return w;
  }

  // Kurze Auswertung vor dem Ergebnis: baut Spannung auf, Zeile für Zeile ein Haken
  function baueAuswertung() {
    var A = D.auswertung;
    var w = el('section', 'kq-screen kq-auswertung');
    var ring = el('div', 'kq-ring');
    ring.innerHTML = '<svg viewBox="0 0 120 120" aria-hidden="true"><circle cx="60" cy="60" r="52" class="kq-ring__spur"/><circle cx="60" cy="60" r="52" class="kq-ring__lauf" pathLength="100"/></svg><span class="kq-ring__zahl">0 %</span>';
    w.appendChild(ring);
    w.appendChild(el('h2', 'kq-frage kq-mitte', A.titel));
    var ul = el('ul', 'kq-schritte');
    var zeilen = A.zeilen.map(function (t) {
      var li = el('li', '');
      var m = el('span', 'kq-schritte__marke');
      m.innerHTML = HAKEN;
      li.appendChild(m);
      li.appendChild(el('span', '', t));
      ul.appendChild(li);
      return li;
    });
    w.appendChild(ul);

    w._nachdemZeigen = function () {
      var dauer = WENIG_BEWEGUNG ? 900 : AUSWERTUNG_MS;
      var zahl = ring.querySelector('.kq-ring__zahl');
      var lauf = ring.querySelector('.kq-ring__lauf');
      var start = performance.now();
      var fertigeZeilen = 0;
      zeilen[0].classList.add('is-aktiv');
      function bild(jetzt) {
        if (!w.isConnected) return; // Weg navigiert
        var t = Math.min(1, (jetzt - start) / dauer);
        var e = 1 - Math.pow(1 - t, 2.2);
        zahl.textContent = Math.round(e * 100) + ' %';
        lauf.style.strokeDashoffset = String(100 - e * 100);
        var soll = Math.min(zeilen.length, Math.floor(t * zeilen.length + 0.15));
        while (fertigeZeilen < soll) {
          zeilen[fertigeZeilen].classList.remove('is-aktiv');
          zeilen[fertigeZeilen].classList.add('is-fertig');
          funkenAus(zeilen[fertigeZeilen].querySelector('.kq-schritte__marke'), 6, false);
          klang.ding(fertigeZeilen);
          tick(15);
          fertigeZeilen++;
          if (zeilen[fertigeZeilen]) zeilen[fertigeZeilen].classList.add('is-aktiv');
        }
        if (t < 1) requestAnimationFrame(bild);
        else setTimeout(function () { if (w.isConnected) weiter(); }, 350);
      }
      requestAnimationFrame(bild);
    };
    return w;
  }

  function baueMail() {
    var M = D.mail;
    var w = el('section', 'kq-screen');
    w.appendChild(el('h2', 'kq-frage', M.titel));
    w.appendChild(el('p', 'kq-hilfe', M.text));

    var form = el('form', 'kq-form');
    form.noValidate = true;

    function feld(id, label, typ, auto) {
      var f = el('div', 'kq-feld');
      var l = el('label', '', label); l.htmlFor = id;
      var i = document.createElement('input');
      i.id = id; i.type = typ; i.autocomplete = auto;
      if (typ === 'email') i.inputMode = 'email';
      f.appendChild(l); f.appendChild(i);
      form.appendChild(f);
      return i;
    }
    var inName = feld('kq-vorname', M.feldVorname, 'text', 'given-name');
    var inMail = feld('kq-email', M.feldEmail, 'email', 'email');

    var zust = el('label', 'kq-zustimmung');
    var haken = document.createElement('input');
    haken.type = 'checkbox'; // niemals vorangekreuzt
    zust.appendChild(haken);
    zust.appendChild(el('span', '', M.zustimmung));
    form.appendChild(zust);

    var ds = el('p', 'kq-datenschutz', M.datenschutzHinweis + ' ');
    var dsLink = el('a', '', M.datenschutzLinkText);
    dsLink.href = D.config.datenschutzUrl; dsLink.target = '_blank'; dsLink.rel = 'noopener';
    ds.appendChild(dsLink);
    ds.appendChild(document.createTextNode('.'));
    form.appendChild(ds);

    var fehler = el('p', 'kq-fehler');
    fehler.setAttribute('role', 'alert');
    form.appendChild(fehler);

    var absenden = el('button', 'kq-knopf', M.knopf);
    absenden.type = 'submit';
    form.appendChild(absenden);

    form.addEventListener('submit', function (ev) {
      ev.preventDefault();
      var mail = inMail.value.trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)) { fehler.textContent = M.fehlerEmail; nachklang(inMail, 'is-wackel', 400); klang.fehler(); tick(40); inMail.focus(); return; }
      if (!haken.checked) { fehler.textContent = M.fehlerZustimmung; nachklang(zust, 'is-wackel', 400); klang.fehler(); tick(40); return; }
      fehler.textContent = '';
      absenden.disabled = true;
      vorname = inName.value.trim();
      melden('quiz_mail_eingetragen', { muster: zustand.muster });
      // Ergebnis wird immer gezeigt, auch wenn das Mailtool hakt.
      mailEintragen({ vorname: vorname, email: mail, muster: zustand.muster, antworten: zustand.antworten })
        .catch(function () {})
        .then(weiter);
    });

    w.appendChild(form);

    var skip = el('div', 'kq-mitte');
    var skipLink = el('button', 'kq-link', M.ueberspringen);
    skipLink.type = 'button';
    skipLink.addEventListener('click', function () {
      melden('quiz_mail_uebersprungen', { muster: zustand.muster });
      weiter();
    });
    skip.appendChild(skipLink);
    w.appendChild(skip);
    return w;
  }

  function antwortOption(nr) {
    var s = D.schritte.filter(function (x) { return x.nr === nr; })[0];
    var a = zustand.antworten[nr];
    if (!s || a == null) return null;
    return (s.optionen || []).filter(function (x) { return x.wert === a; })[0] || null;
  }

  function baueErgebnis() {
    var muster = zustand.muster;
    // Nach einem Neuladen ist das Muster weg, bei Punktewertung laesst es sich neu rechnen.
    if (!muster && istPunktewertung()) muster = zustand.muster = musterAusPunkten();
    var E = D.ergebnisse[muster];
    var T = D.ergebnis;
    var w = el('section', 'kq-screen kq-ergebnis');

    if (!E) { // z.B. nach Neuladen ohne Antwort auf Frage 1
      w.appendChild(el('h1', 'kq-titel', D.start.titel));
      w.appendChild(knopf(D.start.knopf, '', neuStarten));
      return w;
    }

    einmalMelden('ergebnis-' + muster, 'quiz_ergebnis', { muster: muster });

    var kopf = el('div', 'kq-ergebnis__kopf');
    kopf.appendChild(el('p', 'kq-eyebrow', vorname ? T.eyebrowMitName.replace('{name}', vorname) : T.eyebrow));
    var titel = el('h1', 'kq-titel', E.titel);
    kopf.appendChild(titel);
    w.appendChild(kopf);

    // Spiegelt nur ihre eigenen Angaben zurück, keine Bewertung.
    var punkte = [];
    // Welche Fragen gespiegelt werden, steht in config.spiegel. Ohne Angabe wie bisher Frage 1 und 9.
    var spiegel = (D.config && D.config.spiegel) || [1, 9];
    spiegel.forEach(function (nr) {
      var o = antwortOption(nr);
      if (o) punkte.push(o.kurz || o.text);
    });
    var reglerNr = (D.config && D.config.spiegelRegler != null) ? D.config.spiegelRegler : 3;
    if (typeof zustand.antworten[reglerNr] === 'number') punkte.push((T.reglerLabel || '{wert} von 10').replace('{wert}', zustand.antworten[reglerNr]));
    if (punkte.length) {
      var z = el('div', 'kq-zusammenfassung kq-staffel');
      z.appendChild(el('h2', '', T.zusammenfassungTitel));
      var ul = el('ul');
      punkte.forEach(function (p) { ul.appendChild(el('li', '', p)); });
      z.appendChild(ul);
      w.appendChild(z);
    }

    E.einordnung.forEach(function (absatz) { w.appendChild(el('p', 'kq-absatz kq-staffel', absatz)); });

    /* Bedingte Zusaetze: Bei Tests, in denen eine Frage das Ergebnis bestimmt,
       aendern die uebrigen Antworten sonst gar nichts, und der Text kann ihnen
       widersprechen. Ein Ergebnis kann deshalb "wenn" tragen:
         "wenn": [ { "frage": 5, "wert": "er-hat-beendet", "text": "..." } ]
       "wert" darf ein einzelner Wert oder eine Liste sein. Bei Mehrfachfragen
       zaehlt, ob der Wert unter den gewaehlten ist. Trifft mehr als eine
       Bedingung zu, erscheinen alle in der angegebenen Reihenfolge. */
    (E.wenn || []).forEach(function (zusatz) {
      var a = zustand.antworten[zusatz.frage];
      if (a == null) return;
      var gewaehlt = Array.isArray(a) ? a : [a];
      var gesucht = Array.isArray(zusatz.wert) ? zusatz.wert : [zusatz.wert];
      var trifft = gesucht.some(function (v) { return gewaehlt.indexOf(v) > -1; });
      if (trifft && zusatz.text) {
        w.appendChild(el('p', 'kq-absatz kq-staffel', zusatz.text));
      }
    });

    var ent = el('div', 'kq-entlastung kq-staffel');
    ent.appendChild(el('span', '', T.entlastungLabel));
    ent.appendChild(el('p', '', E.entlastung));
    w.appendChild(ent);

    w.appendChild(el('h2', 'kq-untertitel kq-staffel', T.hilftTitel));
    var ol = el('ol', 'kq-hilft kq-staffel');
    E.hilft.forEach(function (p) { ol.appendChild(el('li', '', p)); });
    w.appendChild(ol);

    w.appendChild(el('p', 'kq-uebergang kq-staffel', E.uebergang));

    var cta = el('a', 'kq-knopf kq-knopf--cta kq-staffel', E.knopf || T.knopf);
    cta.href = buchLink(muster);
    cta.addEventListener('click', function (ev) { welle(cta, ev); klang.weiter(); tick(25); melden('quiz_zum_buch', { muster: muster }); });
    w.appendChild(cta);

    // Weitere Tests zum selben Buch (nur wenn die Quiz-Daten "weitere" mitbringen, z. B. Claras Tests)
    if (D.weitere && D.weitere.length) {
      var wt = el('div', 'kq-zusammenfassung kq-staffel');
      wt.appendChild(el('h2', '', D.weitereTitel || 'Mach noch einen Test'));
      var wl = el('ul');
      D.weitere.forEach(function (t) {
        var li = el('li');
        var a = el('a', '', t.titel);
        var u = new URL(t.url, location.origin);
        Object.keys(utm).forEach(function (k) { u.searchParams.set(k, utm[k]); });
        a.href = u.pathname + u.search;
        a.style.color = 'inherit';
        a.addEventListener('click', function () { melden('quiz_weiterer_test', { ziel: t.id || t.url }); });
        li.appendChild(a);
        wl.appendChild(li);
      });
      wt.appendChild(wl);
      w.appendChild(wt);
    }

    var neu = el('div', 'kq-mitte');
    var neuLink = el('button', 'kq-link', T.neuStarten);
    neuLink.type = 'button';
    neuLink.addEventListener('click', neuStarten);
    neu.appendChild(neuLink);
    w.appendChild(neu);

    // Ergebnis-Moment: zwei Funkenwellen aus dem Titel, Inhalt baut sich gestaffelt auf
    w.querySelectorAll('.kq-staffel').forEach(function (x, i) { x.style.animationDelay = (250 + i * 90) + 'ms'; });
    w._nachdemZeigen = function () {
      setTimeout(function () { funkenAus(titel, 36, true); klang.ergebnis(); tick(45); }, 200);
      setTimeout(function () { funkenAus(titel, 24, true); }, 450);
    };
    return w;
  }

  function neuStarten() {
    zustand = { pos: 0, antworten: {}, muster: null, gemeldet: {} };
    vorname = '';
    letzterAnteil = 0;
    zeige(1);
    melden('quiz_start');
  }

  /* ---------- Los ---------- */

  // Nach dem Neuladen dort weitermachen, wo sie war. Mailabfrage und Auswertung nicht wiederherstellen.
  var startPos = zustand.pos;
  while (ablauf[startPos] && (ablauf[startPos].typ === 'mail' || ablauf[startPos].typ === 'auswertung')) startPos--;
  if (startPos < 0 || startPos >= ablauf.length) startPos = 0;
  zeige(startPos);
})();
